import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useRouteTitle } from './useRouteTitle';
import messages from '../components/Header/messages';

/**
 * Enhanced title management hook that handles both header and SEO titles
 * @returns {object} - Route configuration and title utilities
 */
export const useTitleManager = () => {
  const intl = useIntl();
  const routeConfig = useRouteTitle();

  // Get the formatted title text
  const getTitleText = useCallback(
    (titleKey = routeConfig.title) => {
      // Handle dynamic titles based on route parameters
      let actualTitleKey = titleKey;

      if (routeConfig.dynamicTitle && routeConfig.getTitleFromParams) {
        actualTitleKey = routeConfig.getTitleFromParams(routeConfig.params);
      }

      const messageKey = messages[actualTitleKey]
        ? actualTitleKey
        : 'welcomeText';
      return intl.formatMessage(messages[messageKey]);
    },
    [intl, routeConfig],
  );

  // Get SEO title with environment prefix
  const getSEOTitle = useCallback(
    (titleKey = routeConfig.title, dynamicTitle = null) => {
      const titleText = dynamicTitle || getTitleText(titleKey);
      return titleText;
    },
    [getTitleText, routeConfig.title],
  );

  return {
    routeConfig,
    getTitleText,
    getSEOTitle,
  };
};
